import type { JSX } from 'react';

// eslint-disable-next-line internal-rules/no-restricted-design-system-imports
import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';

import { withPrefetchedData } from 'src/shared/prefetch';

import type { ImpactPagePrefetchedDataProps } from 'src/app/pages/about/impact/pageContext';
import { ImpactPageContextProvider, prefetchPageContext } from 'src/app/pages/about/impact/pageContext';

import { Layout } from '../layout';

import { ImpactErrorHandler } from './ErrorHandler';

export const Impact = withPrefetchedData(
	function Impact({ prefetchedData }: ImpactPagePrefetchedDataProps): JSX.Element {
		return (
			<ImpactPageContextProvider
				prefetchedData={prefetchedData}
				errorHandler={ImpactErrorHandler}
				loadingFallback={<Loader size="m" my={256} mx="auto" />}
			>
				<Layout />
			</ImpactPageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		prefetchData: async (context) => prefetchPageContext(context),
	},
);
